import { createAction } from '@reduxjs/toolkit';

export const SET_REFERENCED_RECORD = 'SET_REFERENCED_RECORD';

export interface SetReferencedRecordAction {
  referenceField: string;
  referenceKey: string;
  record: string;
}

export const setReferencedRecord = createAction<SetReferencedRecordAction>(
  SET_REFERENCED_RECORD,
);
